<template>
  <div class="d-flex flex-column justify-end">
    <text-field
      :required="required"
      type="text"
      :model-value="modelValue"
      @update:model-value="$emit('update:model-value', $event)"
      :rules="rules"
      :tooltipText="tooltipText"
      :label="translatedLabel"
      :data-testid="$attrs['test-id']"></text-field>
    <div class="search-btn d-flex align-end justify-end">
      <a href="#" @click="search">
        {{ $t('forms.elements.inputs.streetField.buttons.searchForAnAddress') }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: String,
      default: null
    },
    rules: {
      type: Array,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    label: {
      type: String
    },
    tooltipText: {
      type: String,
      required: false,
      default: 'Address of the Warehouse location visible to carriers'
    }
  },
  methods: {
    search(e) {
      e.preventDefault();
      this.$emit('search');
    }
  },
  computed: {
    translatedLabel() {
      return this.label ?? this.$t('forms.elements.inputs.streetField.labels.streetAddress');
    }
  }
};
</script>

<style scoped>
.search-btn {
  width: 100%;
  z-index: 3;
  margin-top: -12px;
  font-size: 14px;
  text-align: right;
}
</style>
